import { ApiPaginationBody } from "../../../types/pagination";
import { getAxiosClient } from "../../axios-client";
import { GetByLoggedSubcontractorResponse } from "./types";

const axiosClient = getAxiosClient();
export const getByLoggedSubcontractor = async (body: ApiPaginationBody) => {
  return await axiosClient.ax.post<GetByLoggedSubcontractorResponse>(
    "/Warehouses/GetByLoggedSubcontractor",
    body
  );
};
